var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedEvents(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Navigation, Property 2=Closed Events"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.32629 2.5H17.7354C17.874 2.5 18.0048 2.53318 18.1204 2.59203C18.2693 2.66356 18.3988 2.7791 18.4876 2.93288L20.8048 6.94627C20.9275 7.11231 21 7.31768 21 7.53998V20.76C21 21.3123 20.5523 21.76 20 21.76H4C3.44772 21.76 3 21.3123 3 20.76V7.53998C3 7.52467 3.00034 7.50945 3.00102 7.4943C3.00229 7.37182 3.03009 7.24815 3.08674 7.13199C3.11169 7.07623 3.14159 7.02318 3.17589 6.97339L5.50868 2.93288C5.65863 2.67316 5.92495 2.52251 6.20375 2.50877C6.24377 2.50299 6.28468 2.5 6.32629 2.5ZM18.6072 6.53998H5.38911L6.7401 4.2H17.2562L18.6072 6.53998ZM4.7 8.239H19.3V20.06H4.7V8.239ZM9.35 11C8.88056 11 8.5 11.3806 8.5 11.85C8.5 12.3194 8.88056 12.7 9.35 12.7H14.65C15.1194 12.7 15.5 12.3194 15.5 11.85C15.5 11.3806 15.1194 11 14.65 11H9.35Z",
    fill: "#006CB7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEvents);
export default __webpack_public_path__ + "static/media/closed_events.ef74f06980ba6524755d6a4eb0cbf594.svg";
export { ForwardRef as ReactComponent };